
import { Image } from 'vue-datocms'

export default {
  components: {
    'datocms-image': Image,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },

  computed: {
    permaLink() {
      return `/lessons/${this.slug}`
    },
  },
}
